import {Component, Input, OnInit} from "@angular/core";
import {Product} from "../../../shared/view-model/store-management/product.type";
import {ProductFormComponent} from "../product-form/product-form.component";
import {FormBuilder, FormGroup} from "@angular/forms";

@Component({
  selector: 'vb-edit-product',
  templateUrl: './edit-product.component.html',
  styleUrls: ['./edit-product.component.css']
})
export class EditProductComponent implements OnInit {

  @Input()
  product: Product;

  productForm: FormGroup;

  constructor(private fb: FormBuilder,) {
  }

  ngOnInit() {
    let values = Object.assign({}, this.product);
    this.initProductForm(values);
  }

  initProductForm(values?) {
    this.productForm = ProductFormComponent.initControl(this.fb);
  }

  save() {
    let itemCuid = "";
    let productData = this.productForm ? this.productForm.value : {};

    console.info("Save: " + JSON.stringify(this.productForm.value));
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/product/edit-product/edit-product.component.ts